import { OptionDto } from "@/dtos";
import { SiteType } from "@/helpers/types";

const siteTypes = [
    { value: SiteType.MOBILE, label: 'Móvil' },
    { value: SiteType.STOP, label: 'Parada' },
    { value: SiteType.PLACE, label: 'Lugar' },
    { value: SiteType.EXTERNAL_PROVIDER, label: 'Provedor Externo' },
    { value: SiteType.VEHICLE, label: 'Vehículo' },
] as OptionDto[];

export const getSiteTypeOptions = (): OptionDto[] => {
    return siteTypes;
}

export const getSiteTypeOption = (value?: number): OptionDto => {
    return siteTypes.find((x) => x.value == value) ?? siteTypes[0];
}

export const getSiteTypeLabel = (value: number): string => {
    return siteTypes.find((x) => x.value == value)?.label ?? siteTypes[0].label;
}